class FileInput {
  fileInput;
  textInput;
  fileIcon;
  fileButton;
  maxFileSize;
  errorTextElement;

  init(
    fileInputSelector,
    textInputSelector,
    fileIconSelector,
    fileButtonSelector,
    errorTextSelector,
    maxFileSize = 25 * 1024 * 1024
  ) {
    this.fileInput = document.querySelector(fileInputSelector);
    this.textInput = document.querySelector(textInputSelector);
    this.fileIcon = document.querySelector(fileIconSelector);
    this.fileButton = document.querySelector(fileButtonSelector);
    this.errorTextElement = document.querySelector(errorTextSelector);
    this.maxFileSize = maxFileSize;

    if (this.fileInput) {
      this.fileInput.addEventListener('change', () =>
        this.handleFileInputChange()
      );
    }

    if (this.fileButton) {
      this.fileButton.addEventListener('click', () => this.resetFileInput());
    }
  }

  handleFileInputChange() {
    const file = this.fileInput.files[0];

    if (!file) {
      this.clearError();
      return;
    }

    if (file.size > this.maxFileSize) {
      this.showError();
      return;
    }

    this.textInput.textContent = file.name;
    this.fileIcon.style.display = 'block';
    this.textInput.classList.add('no-underline');
    this.fileButton.classList.add('close-file');

    this.clearError();
  }

  resetFileInput() {
    this.fileInput.value = '';
    this.textInput.textContent = 'Выбрать файл';
    this.fileIcon.style.display = 'none';
    this.textInput.classList.remove('no-underline');
    this.fileButton.classList.remove('close-file');

    this.clearError();
  }

  showError() {
    this.errorTextElement.textContent = 'Ваш файл превышает 25 МБ';
    this.errorTextElement.style.color = '#D93F40';
    this.fileInput.value = '';
    this.textInput.textContent = 'Выбрать файл';
    this.fileIcon.style.display = 'none';
    this.textInput.classList.remove('no-underline');
    this.fileButton.classList.remove('close-file');
  }

  clearError() {
    this.errorTextElement.textContent =
      'Можно прикрепить к форме файл до 25 МБ';
    this.errorTextElement.style.color = '';
  }
}

export const fileInput = new FileInput();
